import {
  Component,
  OnInit,
  Output,
  EventEmitter,
  OnDestroy,
  AfterViewInit
} from '@angular/core'
import { AmChartsService } from '@amcharts/amcharts3-angular'
import { CpmService } from '../../service/cpm.service'
import { ExportExcelService } from 'app/service/export-excel.service'
import { ExportPPTService } from 'app/service/export-ppt.service'
import { ActivatedRoute } from '@angular/router'
import { environment } from '../../../environments/environment'
import { Router } from '@angular/router'

@Component({
  selector: 'app-market-cap-rank-top-security',
  templateUrl: './market-cap-rank-top-security.component.html',
  styleUrls: ['./market-cap-rank-top-security.component.scss']
})
export class MarketCapRankTopSecurityComponent implements OnInit, OnDestroy, AfterViewInit {
  listOfIndustries = [
    {
      id: '0',
      name: 'Automobiles & Parts',
      isChecked: false
    },
    {
      id: '1',
      name: 'Banks',
      isChecked: false
    },
    {
      id: '2',
      name: 'Basic Resources',
      isChecked: false
    },
    {
      id: '3',
      name: 'Chemicals',
      isChecked: false
    },
    {
      id: '4',
      name: 'Construction & Materials',
      isChecked: false
    },
    {
      id: '5',
      name: 'Financial Services',
      isChecked: false
    },
    {
      id: '6',
      name: 'Food & Beverage',
      isChecked: false
    },
    {
      id: '7',
      name: 'Health Care',
      isChecked: false
    },
    {
      id: '8',
      name: 'Industrial Goods & Services',
      isChecked: false
    },
    {
      id: '9',
      name: 'Insurance',
      isChecked: false
    },
    {
      id: '10',
      name: 'Media',
      isChecked: false
    },
    {
      id: '11',
      name: 'Oil & Gas',
      isChecked: false
    },
    {
      id: '12',
      name: 'Personal & Household',
      isChecked: false
    },
    {
      id: '13',
      name: 'Real Estate',
      isChecked: false
    },
    {
      id: '14',
      name: 'Retail',
      isChecked: false
    },
    {
      id: '15',
      name: 'Technology',
      isChecked: false
    },
    {
      id: '16',
      name: 'Telecommunications',
      isChecked: false
    },
    {
      id: '17',
      name: 'Travel & Leisure',
      isChecked: false
    },
    {
      id: '18',
      name: 'Utilities',
      isChecked: false
    }
  ]
  securityTableOptions: DataTables.Settings = {}
  securityMarketCapData = new Map()
  countryList = []
  limitCheckedNumber = 3
  dataChart
  chart
  asOfDate
  getPrint
  checkboxValue = new Map()
  exchangeStatistic = new Map()
  topRank = '0'

  @Output() param = new EventEmitter()

  constructor(
    private amCharts: AmChartsService,
    private excelService: ExportExcelService,
    private pptService: ExportPPTService,
    private cpmService: CpmService,
    private activatedRoute: ActivatedRoute,
    private router: Router
  ) { }

  ngOnInit() {
    const { print } = this.activatedRoute.snapshot.data
    this.getPrint = print;
    this.securityTableOptions = {
      autoWidth: false,
      paging: false,
      searching: false,
      info: false,
      ordering: false
    }

    this.loadData().then(() => {
      this.cpmService
        .getExchangeStatistic()
        .then(response => {
          this.exchangeStatistic = response
        })
        .then(() => {
          const { topRank } = this.activatedRoute.snapshot.params
          const { checkedIndustries } = this.activatedRoute.snapshot.params

          if (topRank && checkedIndustries) {
            this.topRank = topRank
            checkedIndustries.split(',').forEach(id => {
              const item = this.listOfIndustries.find(v => v.id === id)
              this.check(item)
            })
          } else {
            // trigger check third element
            this.check(this.listOfIndustries[0])
            this.check(this.listOfIndustries[1])
            this.check(this.listOfIndustries[2])
          }
        })
    })
    if (document.getElementById('chartdiv')) {
      document.getElementById('chartdiv').classList.add('chartFinished')
    }
  }

  ngOnDestroy() {
    if (this.chart && this.chart.legend && this.chart.legend.destroy) {
      const tmp =
        this.chart != null ? this.amCharts.destroyChart(this.chart) : null
    }
  }

  async loadData() {
    await this.cpmService.getExchangeStatisticByIndustry().then(obj => {
      this.asOfDate = obj.asOfDate
      return this.mapExchangeList(obj.exchangeStatistic)
    })
  }

  mapExchangeList(exchangeList) {
    exchangeList.forEach(x => {
      this.countryList.push(x.country)
    })
  }

  getCountryMarketCap(country, marketCap) {
    const industry = this.getIndustry(marketCap)
    return this.exchangeStatistic
      .get(country)
      .get(industry)
      .get('marketCap')
  }

  getMappingArrayOfTopRankMarketCap() {
    return Array.from(this.securityMarketCapData)
  }

  getIndustry(marketCap) {
    return marketCap[0]
  }

  getSecurityData(marketCap) {
    return marketCap[1]
  }

  getNoOfCompany(marketCap) {
    const industry = this.getIndustry(marketCap)
    let total = 0
    this.exchangeStatistic.forEach(v => {
      total += v.get(industry).get('noOfCompany')
    })
    return total + ' units'
  }

  getTotalMarketCapByIndustry(marketCap) {
    const industry = this.getIndustry(marketCap)
    return this.getTotalMarketCapByIndustryString(industry)
  }

  getTotalMarketCapByIndustryString(industry): Number {
    let total = 0
    this.exchangeStatistic.forEach(v => {
      total += v.get(industry).get('marketCap')
    })
    return total
  }

  getTotalMarketCapForExport() {
    const allTotalMarket = new Map()
    this.checkboxValue.forEach((v, i) => {
      allTotalMarket.set(i, this.getTotalMarketCapByIndustryString(i))
    })
    return allTotalMarket
  }

  getTotalEachIndustryByCountryForExport() {
    const allTotalEachIndustryByCountry = new Map()
    this.listOfIndustries.filter(e => e.isChecked === true).forEach(e => {
      const allTotalEachCountry = new Map()
      this.countryList.forEach(country => {
        allTotalEachCountry.set(
          country,
          this.exchangeStatistic.get(country).get(e.name)
        )
      })
      let total = 0
      this.exchangeStatistic.forEach(v => {
        total += v.get(e.name).get('noOfCompany')
      })
      allTotalEachIndustryByCountry.set(e.name, {
        country: allTotalEachCountry,
        allUnit: total
      })
    })
    return allTotalEachIndustryByCountry
  }

  check(item) {
    item.isChecked = !item.isChecked
    if (item.isChecked) {
      this.checkboxValue.set(item.name, item.isChecked)
      this.updateData(item)
    } else {
      this.checkboxValue.delete(item.name)
      this.securityMarketCapData.delete(item.name)
    }
  }

  changeTopRank() {
    this.listOfIndustries.forEach(item => {
      if (item.isChecked) {
        // clear data before update
        this.securityMarketCapData = new Map()
        this.updateData(item)
      }
    })
  }

  getTopRank() {
    return this.topRank === '0' ? 3 : 10
  }

  exceedLimitChecked(industry) {
    return (
      !industry.isChecked && this.checkboxValue.size === this.limitCheckedNumber
    )
  }

  async updateData(item) {
    this.cpmService
      .getExchangeTopMarketCap(this.getTopRank(), item.name)
      .then(data => {
        const tempMappingCountryArray = []
        data.topSecurities.forEach(function (v, i) {
          const tempMapping = {}
          tempMapping['securityName'] = v.securityName
          tempMapping['total'] = v.marketCap
          tempMapping[v.country] = v.marketCap
          tempMappingCountryArray[i] = tempMapping
        })
        this.securityMarketCapData.set(item.name, tempMappingCountryArray)
      })
  }

  getCheckedId() {
    const checkedIds = []
    Array.from(this.securityMarketCapData.keys()).forEach(name => {
      const item = this.listOfIndustries.find(v => v.name === name)
      checkedIds.push(item.id)
    })
    return checkedIds
  }

  async mail() {
    const filename = await this.cpmService.saveMarketCapSecurityRankPdfFile(
      this.topRank,
      this.getCheckedId()
    )
    const downloadUrl = encodeURIComponent(
      `${environment.cpmBaseUrl}/download?type=report&filename=${filename}`
    )
    const emailTitle = `ASEAN Exchanges: Top ${this.getTopRank()} Rank Securities (M. USD)`
    this.mailToUrl(emailTitle, downloadUrl)
  }

  mailToUrl(subject, url) {
    window.location.href = `mailto:?subject=${subject}&body=${url}`
  }

  print() {
    const checkedIds = this.getCheckedId()
    this.router.navigate([
      'marketCapSecurityRank/' + this.topRank + '/' + checkedIds.join()
    ])
  }

  pdf() {
    const checkedIds = this.getCheckedId()
    const service = this.cpmService
    service.downloadFile(
      `${environment.cpmBaseUrl}/pdf/marketCapSecurityRank?` +
      'topRank=' +
      this.topRank +
      '&checkedIndustries=' +
      checkedIds.join()
    )
  }

  excel() {
    const allTotalMarket = this.getTotalMarketCapForExport()
    const totalEachIndustryByCountry = this.getTotalEachIndustryByCountryForExport()
    // console.log(totalEachIndustryByCountry)
    this.excelService.exportMarketCapTopSecurityRank(
      this.countryList,
      this.getTopRank(),
      allTotalMarket,
      totalEachIndustryByCountry,
      this.securityMarketCapData
    )
  }
  numberToNoDecimal(num) {
    return Number(parseFloat(num).toFixed(0)).toLocaleString('en')
  }

  ngAfterViewInit() {
    if (this.getPrint) {
      window.setTimeout('window.print()', 7000);
    }
  }

}



// WEBPACK FOOTER //
// /opt/alm/jenkins/workspace/mis-cpm/mis-cpm-prod-front/src/app/market-level/market-cap-rank-top-security/market-cap-rank-top-security.component.ts